import axios from "../../../configs/axios";

export interface GraphicsItem {
  id: string;
  title: string;
  description: string;
  category: string;
  fileKey?: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateGraphicsRequest {
  title: string;
  description: string;
  category: string;
  fileKey?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export interface UpdateGraphicsRequest {
  title?: string;
  description?: string;
  category?: string;
  fileKey?: string;
  isActive?: boolean;
  sortOrder?: number;
}

export const graphicsAPI = {
  getAllItems: async (search?: string) => {
    const params = search ? { search } : {};
    const response = await axios.get("/admin/graphics", { params });
    return response.data.data;
  },

  getItemById: async (id: string) => {
    const response = await axios.get(`/admin/graphics/${id}`);
    return response.data.data;
  },

  createItem: async (data: CreateGraphicsRequest) => {
    const response = await axios.post("/admin/graphics", data);
    return response.data.data;
  },

  createItemWithFile: async (data: CreateGraphicsRequest, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("category", data.category);
    if (data.isActive !== undefined) {
      formData.append("isActive", data.isActive.toString());
    }
    if (data.sortOrder !== undefined) {
      formData.append("sortOrder", data.sortOrder.toString());
    }

    const response = await axios.post("/admin/graphics", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  },

  updateItem: async (id: string, data: UpdateGraphicsRequest) => {
    const response = await axios.put(`/admin/graphics/${id}`, data);
    return response.data.data;
  },

  updateItemWithFile: async (
    id: string,
    data: UpdateGraphicsRequest,
    file: File
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    if (data.title) formData.append("title", data.title);
    if (data.description) formData.append("description", data.description);
    if (data.category) formData.append("category", data.category);
    if (data.isActive !== undefined) {
      formData.append("isActive", data.isActive.toString());
    }
    if (data.sortOrder !== undefined) {
      formData.append("sortOrder", data.sortOrder.toString());
    }

    const response = await axios.put(`/admin/graphics/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  },

  deleteItem: async (id: string) => {
    const response = await axios.delete(`/admin/graphics/${id}`);
    return response.data;
  },

  getDownloadUrl: async (id: string) => {
    const response = await axios.get(`/admin/graphics/${id}/download`);
    return response.data.data.downloadUrl;
  },

  getPreviewUrl: async (id: string): Promise<string> => {
    const response = await axios.get(`/admin/graphics/${id}/download`);
    return response.data.data.downloadUrl;
  },
};
